import Swiper from "swiper";

const thumbs = document.querySelector(".js-product-page-slider-thumbs");
const pagination = document.querySelector(".js-product-page-card-pagination");

const pageSliderThumbs = new Swiper(thumbs, {
    spaceBetween: 8,
    slidesPerView: "auto",
    direction: "vertical",
    allowTouchMove: false,
});

new Swiper(".js-product-page-slider", {
    spaceBetween: 16,
    watchOverflow: true,

    pagination: {
        el: pagination,
        clickable: true,
        type: "progressbar",
    },
    thumbs: {
        swiper: pageSliderThumbs,
        slideThumbActiveClass: "active",
    },
});

const instructionsBlock = document.querySelector(".js-product-page-card-instructions");

if (instructionsBlock) {
    const showAllInstructionsBtn = instructionsBlock.querySelector(
        ".js-product-page-card-instructions-title",
    );
    const instructionsList = instructionsBlock.querySelector(
        ".js-product-page-card-instructions-list",
    );

    if (instructionsList) {
        const instructionsItems = instructionsList.querySelectorAll(
            ".js-product-page-card-instructions-item",
        );

        if (instructionsItems && instructionsItems.length > 2) {
            hideInstructionsItems();

            if (showAllInstructionsBtn) {
                showAllInstructionsBtn.addEventListener("click", () => {
                    instructionsBlock.style.height = `${instructionsBlock.offsetHeight}px`;

                    if (instructionsBlock.classList.contains("closed")) {
                        instructionsBlock.classList.remove("closed");

                        for (let i = 2; i < instructionsItems.length; i++) {
                            instructionsItems[i].classList.remove("hidden");
                        }
                    } else {
                        hideInstructionsItems();
                    }
                });
            }
        } else {
            instructionsBlock.classList.add("default-state");
        }
    }
}

function hideInstructionsItems() {
    const instructionsItems = instructionsBlock.querySelectorAll(
        ".js-product-page-card-instructions-item",
    );

    instructionsBlock.classList.add("closed");

    for (let i = 2; i < instructionsItems.length; i++) {
        instructionsItems[i].classList.add("hidden");
    }
}
